import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogger } from "@noom/hive-analytics";
import {
  Box,
  Button,
  CompassColor,
  H5,
  Image,
  P3,
  Stack,
} from "@noom/wax-component-library";

import { MixpanelTypes } from "../common/types";
import errorIcon from "../image_assets/marketplace_error_icon.svg";

export const NotFoundPage = () => {
  const { t } = useTranslation("common", { useSuspense: false });
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const mixpanelLogger = useLogger();

  useEffect(() => {
    try {
      mixpanelLogger.log(MixpanelTypes.OnNotFoundPage, { path: pathname });
    } catch {
      console.error("error loading mixpanel");
    }
  }, [mixpanelLogger, pathname]);

  return (
    <Box
      data-cy="not-found-page"
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={6}
    >
      <Stack spacing={6} align="center" maxWidth="360px">
        <Image src={errorIcon} alt="" width="108px" height="108px" />
        <Stack spacing={2} align="center">
          <H5
            fontWeight="400"
            fontSize="28px"
            lineHeight="34px"
            textAlign="center"
          >
            {t("notFound.title")}
          </H5>
          <P3 textAlign="center">{t("notFound.body")}</P3>
        </Stack>
        <Button
          size="md"
          borderRadius="56px"
          bg={CompassColor.lagoon}
          color={CompassColor.white}
          onClick={() => navigate("/")}
          data-cy="not-found-go-home"
        >
          {t("notFound.goHome")}
        </Button>
      </Stack>
    </Box>
  );
};
